/**
 * WordPress dependencies
 */
import { link, linkOff } from '@safe-wordpress/icons';
import {
	Button,
	type WordPressComponentProps,
} from '@safe-wordpress/components';
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { contextConnect } from '../../context';
import { useBorderBoxControlLinkedButton } from './hook';
import type { LinkedButtonProps } from '../types';

const BorderBoxControlLinkedButton = (
	props: WordPressComponentProps< LinkedButtonProps, 'button' >,
	forwardedRef: React.ForwardedRef< unknown >
) => {
	const { className, isLinked, ...buttonProps } =
		useBorderBoxControlLinkedButton( props );
	const label = isLinked
		? _x( 'Unlink sides', 'command', 'nelio-ab-testing' )
		: _x( 'Link sides', 'command', 'nelio-ab-testing' );

	return (
		<Button
			{ ...buttonProps }
			size="small"
			icon={ isLinked ? link : linkOff }
			iconSize={ 24 }
			label={ label }
			ref={ forwardedRef }
			className={ className }
		/>
	);
};

const ConnectedBorderBoxControlLinkedButton = contextConnect(
	BorderBoxControlLinkedButton,
	'BorderBoxControlLinkedButton'
);
export default ConnectedBorderBoxControlLinkedButton;
